import { Link } from 'react-router-dom';

const AboutSection: React.FC = () => {
  return (
    <section className="py-16 sm:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative">
            <div className="relative h-96 sm:h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/c82a80d6d696663c2db3260ddbcff61b/904687f3a2323121c6cdb91fcceb8362.png"
                alt="J's Landscaping Services Team"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#83B328] text-white p-6 rounded-xl shadow-xl hidden sm:block">
              <div className="text-4xl font-bold">9+</div>
              <div className="text-sm font-semibold">Years Experience</div>
            </div>
          </div>

          <div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About <span className="text-[#83B328]">J's Landscaping</span>
            </h2>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              With over 9 years of dedicated service in Maryland, J's Landscaping Services LLC has built a reputation for excellence in landscaping and complete property management. We're not just landscapers – we're your full-service property partners.
            </p>

            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              From routine lawn maintenance to complex project management, we handle everything. If we don't offer a service directly, we'll connect you with licensed contractors and manage the entire process, ensuring quality results while you relax.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#83B328] rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Licensed & Insured</h4>
                  <p className="text-gray-600 text-sm">Fully certified for your protection</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#83B328] rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-customer-service-2-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Expert Team</h4>
                  <p className="text-gray-600 text-sm">Skilled professionals you can trust</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#83B328] rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-star-fill text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">5-Star Rated</h4>
                  <p className="text-gray-600 text-sm">Consistently top-rated service</p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-12 h-12 bg-[#83B328] rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className="ri-map-pin-line text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-1">Local Experts</h4>
                  <p className="text-gray-600 text-sm">Serving 25+ Maryland areas</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link 
                to="/about"
                className="inline-block bg-[#83B328] text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-[#6d9620] transition-colors text-center shadow-lg"
              >
                Learn More About Us
              </Link>
              <a 
                href="#"
                className="call-trigger inline-block border-2 border-[#83B328] text-[#83B328] px-8 py-4 rounded-lg text-lg font-bold hover:bg-[#83B328] hover:text-white transition-colors text-center"
                data-phone="4438191521"
              >
                Call (443) 819-1521
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
